<template>
  <div class="card">
    <div class="media mt-0">
      <div class="media-body">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-11">
              <label :for="'tickets_description_' + index" class="required">
                Name
              </label>
              <input type="text" class="form-control form-control-lg"
                :name="'tickets_description_' + index" :key="'tickets_description_' + index"
                v-model="ticket.description" v-validate="'required'" data-vv-as="Name"
              />
              <span v-show="errors.has('tickets_description_' + index)" class="input-error">
                {{ errors.first('tickets_description_' + index) }}
              </span>
            </div>
            <div class="col-lg-1">
              <button v-show="showRemoveTicketButton" type="button"
                class="btn btn-link float-right"
                @click="removeTicket(index, ticket)">
                X
              </button>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-lg-6">
              <label :for="'tickets_quantity_' + index" class="required">
                Quantity
              </label>
              <input type="number" class="form-control form-control-lg"
                :name="'tickets_quantity_' + index" :key="'tickets_quantity_' + index"
                v-model="ticket.quantity" v-validate="'required'"
                data-vv-as="Quantity"
                min="1" step="1"
                v-on:change="updateQuantity()"
              />
              <span v-show="errors.has('tickets_quantity_' + index)" class="input-error">
                {{ errors.first('tickets_quantity_' + index) }}
              </span>
            </div>
            <div class="col-lg-6">
              <label :for="'tickets_price_' + index" class="required">Price</label>
              <CurrencyInput
                v-model="ticket.price"
                data-vv-as="Price"
                class="form-control form-control-lg"
                :name="'tickets_price_' + index"
                :key="'tickets_price_' + index"
                v-validate="'required'"
                v-on:change="updateBuyerTotal()"
              />
              <span v-show="errors.has('tickets_price_' + index)" class="input-error">
                {{ errors.first('tickets_price_' + index) }}
              </span>
              <span v-show="true" class="input-append">
                Buyer total: {{ buyerTotal | currency }}
              </span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="checkbox">
            <input type="hidden" :name="'ticket_cost_cd_' + index"
                    :v-model="ticket.ticket_cost_cd"
                    :key="'ticket_cost_cd_' + index"
                    data-vv-as="Ticket Cost"
            />
            <input type="checkbox" v-model="absorbFees"
                   :name="'absorb_fees_' + index"
                   :id="'absorb_fees_' + index"
                   data-vv-as="Absorb fees: deduct ticketing platform fees from your revenue"
                   v-on:change="updateTicketCost()"
            />
            <label :for="'absorb_fees_' + index">
              Absorb fees: deduct ticketing platform fees from your revenue
            </label>
          </div>
        </div>

        <div class="form-group">
          <label :for="'tickets_purchase_limit_' + index" class="required">
            Max tickets per order
          </label>
          <input type="number" min="1" step="1" class="form-control form-control-lg"
                 :name="'tickets_purchase_limit_' + index" :key="'tickets_purchase_limit_' + index"
                 :disabled="ticket.quantity === null"
                 v-model="ticket.purchase_limit" v-validate="'required|numeric|max_value:' + ticket.quantity" data-vv-as="Max tickets per order" />
          <span v-show="errors.has('tickets_purchase_limit_' + index)" class="input-error">
                {{ errors.first('tickets_purchase_limit_' + index) }}
              </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TicketForm',
  inject: ['$validator'],
  props: {
    absorbFees: {
      required: false,
      type: Boolean,
      default: false
    },
    ticket: {
      required: true,
      type: Object
    },
    applicationSettings: {
      required: true,
      type: Object
    },
    userSettings: {
      required: true,
      type: Object
    },
    showRemoveTicketButton: {
      required: false,
      type: Boolean,
      default: true
    },
    index: {
      required: false,
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      buyerTotal: 0
    }
  },
  mounted () {
    this.updateBuyerTotal()
  },
  watch: {
    'ticket' (newValue, oldValue) {
      this.updateBuyerTotal()
    }
  },
  methods: {
    removeTicket (index, ticket) {
      this.$emit('remove-ticket', index, ticket, 'ticket')
    },
    updateTicketCost () {
      this.ticket.ticket_cost_cd = this.absorbFees ? 0 : 1
      this.updateBuyerTotal('update ticket cost')
    },
    updateQuantity () {
      this.$emit('update-remaining-tickets')
    },
    updateBuyerTotal () {
      if (this.ticket.price > 0) {
        if (this.absorbFees) {
          this.buyerTotal = this.ticket.price / 100
        } else {
          this.buyerTotal = this.calculatePriceWithFee()
        }
      }
    },
    calculatePriceWithFee () {
      const price = this.ticket.price
      const cost = this.inferTicketCost()
      const ticketFeePercentage = this.inferFeePercentage()

      return (ticketFeePercentage / 100) * (price / 100) + (price + cost) / 100
    },
    inferTicketCost () {
      const userSettingCost = this.userSettings.TICKET_FEE_BASE_COST
      const applicationSettingCost = this.applicationSettings.TICKET_FEE_BASE_COST

      return (userSettingCost && userSettingCost.value) ||
        (applicationSettingCost && applicationSettingCost.value)
    },
    inferFeePercentage () {
      const userSettingFeePercentage = this.userSettings.TICKET_FEE_PERCENTAGE
      const applicationSettingFeePercentage = this.applicationSettings.TICKET_FEE_PERCENTAGE

      return (userSettingFeePercentage && userSettingFeePercentage.value) || (applicationSettingFeePercentage && applicationSettingFeePercentage.value)
    }
  }
}
</script>
